import { render, staticRenderFns } from "./PageAssetDetail.vue?vue&type=template&id=f871ee1a"
import script from "./PageAssetDetail.vue?vue&type=script&lang=js"
export * from "./PageAssetDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports